export default {
  text: '{{threshold}} vendite mensili: {{amount}}',
  label: '{{threshold}} vendite mensili:',
  no_discount: 'nessuno sconto',
  discount_badge: '-{{percentage}}%',
};
